// extracted by mini-css-extract-plugin
module.exports = {"base":"AuthToken_base__1sGoc"};